export const ProjectLimits = {
    MAPPING: { SIZE: 300 },
    CONDITION: {
        SIZE: 512,
    },
    PAGE: {
        CONDITIONS: 100,
        CONTAINS: 50,
        REGEX: 10,
    },
    PERIOD: {
        MAX_DAY: 92,
    },
    SEGMENT: {
        GOALS: 9,
        TEXT_SEEN: 2,
    },
    INTEGRATION: {
        SEGMENTS: 100,
    },
    REGEX: {
        MATCH: 5,
        ALTERNATION: 15,
    },
};
//# sourceMappingURL=project.limits.js.map